import { useEffect } from "react";
import { useState } from "react";

import { PanesContainer } from "dev";
import Pusher from "pusher-js";
import { ScrollView } from "react-native";

Pusher.logToConsole = true;

export default function Websocket() {
  const [events, setEvents] = useState<any[]>([]);
  useEffect(() => {
    const pusher = new Pusher("b8ca195b0c403c769cc1", {
      cluster: "mt1",
    });
    const channel = pusher.subscribe("my-channel");
    channel.bind("my-event", function (data: any) {
      console.log("Received event with data: ", data);
      const newEvent = {
        tstamp: new Date().toISOString(),
        payload: data,
      };
      setEvents((events) => [newEvent, ...events]);
    });
    console.log("Websocket connected");
    return () => {
      channel.unbind_all();
      channel.unsubscribe();
      pusher.disconnect();
    };
  }, []);

  return (
    <ScrollView>
      <h1>Websocket</h1>
      <p>Websocket connection to Pusher</p>
      <PanesContainer
        items={events}
        expectedCount={events?.length}
        renderItem={(e) => (
          <>
            <h2>{e.tstamp}</h2>
            <pre>{JSON.stringify(e.payload, null, 2)}</pre>
          </>
        )}
      />
    </ScrollView>
  );
}
